<script lang="ts">
import {defineComponent} from 'vue'

export default defineComponent({
  name: "FormField",
  props: {
    label: {
      type: String,
      required: false
    },
    required: {
      type: Boolean,
      required: false,
      default: false
    },
    is50Width: {
      type: Boolean,
      required: false,
      default: false
    },
    isCheckBox: {
      type: Boolean,
      required: false,
      default: false
    }
  },
})
</script>

<template>
  <div :class="'field' + (is50Width ? ' split-width': '')">
    <label :class="isCheckBox? 'checkbox': ''">
      <span v-if="label && !isCheckBox" class="text">{{ label }}{{ required ? '*': ''}}</span>
      <div class="content">
        <slot></slot>
      </div>
      <span v-if="label && isCheckBox" class="text" v-html="(label+(required ? '*': ''))"></span>
    </label>
  </div>
</template>

<style scoped lang="scss">
.field{
  margin-bottom: 1rem;
  label {
    display: block;
    & > .text {
      margin-bottom: 0.6rem;
      display: block;
    }
    &.checkbox{
      display: flex;
      flex-direction: row;
      align-items: start;
      gap: 0.5rem;
      margin: 1rem 0;
      .p-checkbox{
        width: 20px;
      }
      .text{
        margin-bottom: 0;
      }
    }
  }
  &.split-width{
    width: calc(50% - 0.5rem);
  }
}
.content{
  display: flex;
  gap: 0.2rem;
}
:slotted(textarea){
  min-height: 12rem;
  width: 100%;
}
:slotted(.p-toggleswitch){
  width:  var(--p-toggleswitch-width);
  margin-top: 0.5rem;
}
:slotted(*) {
  width: 100%;
  .p-password-input {
    width: 100%;
  }
}
@media screen and (max-width: (810px)) {
  .field {
    &.split-width {
      width: 100%;
    }
  }
}
</style>